module.exports = __webpack_public_path__ + "img/img-ruleSet-example1.08332334.png";